{
  "name": "La primera cadena montada",
  "commands": [
    { "type": "placeBelt", "tile": "taller", "path": [[0, 3], [1, 3]], "exit": "E" },
    { "type": "placeMachine", "tile": "taller", "machine": "furnace", "cell": [2, 3], "rotation": 0 },
    { "type": "placeBelt", "tile": "taller", "path": [[4, 3]], "exit": "E" },
    { "type": "placeMachine", "tile": "taller", "machine": "press", "cell": [5, 3], "rotation": 0 },
    { "type": "placeBelt", "tile": "taller", "path": [[7, 3]], "exit": "E" },
    { "type": "createRoute", "from": "mina", "to": "taller", "vehicle": "truck" },
    { "type": "createRoute", "from": "taller", "to": "almacen", "vehicle": "truck" }
  ]
}
